import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useMemo } from 'react';
import { MoreHoriz } from '@mui/icons-material';
import { Popover } from '@mui/material';
import { SmallNavigationTab } from './components/small';
import { useAnchor } from 'shared/hooks/utils';
import * as S from '../../styles';
import { getNavigationIcon } from 'console/navigation/icons';
const transformOrigin = {
    vertical: 'bottom',
    horizontal: 'right',
};
const anchorOrigin = {
    vertical: 'top',
    horizontal: 'right',
};
/**
 * @function
 * Отображает от 3 до 5 элементов
 */
export const SmallNavigationTabs = memo(function SmallNavigationTabs(props) {
    const { handles, more_handles, need_more_button, moreTabsSelected, tabs_count, tab_width, } = props;
    const [anchorEl, onMoreOpen, onMoreClose] = useAnchor();
    const current_tab = useMemo(() => handles.findIndex(({ selected }) => selected), [handles]);
    const selected_tab = useMemo(() => (moreTabsSelected ? tabs_count ?? 0 : current_tab), [moreTabsSelected, tabs_count, current_tab]);
    const bottom_tabs = useMemo(() => handles.map((handle) => {
        const { title, key, onClick, iconclass, selected, icon, data_tooltip } = handle;
        return (_jsx(SmallNavigationTab, { icon: icon ?? getNavigationIcon(iconclass), selected: selected, label: title, onClick: () => {
                onClick(false);
                onMoreClose();
            }, width: tab_width, data_tooltip: data_tooltip }, key + title));
    }), [handles, tab_width]);
    const more_tabs = useMemo(() => more_handles?.map((handle) => {
        const { title, key, onClick, iconclass, selected, icon, data_tooltip } = handle;
        return (_jsx(SmallNavigationTab, { icon: icon ?? getNavigationIcon(iconclass), selected: selected, label: title, onClick: () => {
                onClick(false);
                onMoreClose();
            }, width: tab_width, data_tooltip: data_tooltip }, key));
    }), [more_handles]);
    return (_jsxs(_Fragment, { children: [_jsx(S.BottomNavigation, { elevation: 3, className: "MobileUIBottomNavigation", children: _jsxs(S.SmallNavigationTabs, { current_tab_index: selected_tab, tab_width: tab_width, children: [bottom_tabs, need_more_button && (_jsx(SmallNavigationTab, { label: "\u0415\u0449\u0435", icon: _jsx(MoreHoriz, {}), onClick: onMoreOpen, width: tab_width }))] }) }), need_more_button && (_jsx(Popover, { id: "more-tabs", open: Boolean(anchorEl), anchorEl: anchorEl, onClose: onMoreClose, anchorOrigin: anchorOrigin, transformOrigin: transformOrigin, children: _jsx(S.MorePopupContent, { children: more_tabs }) }))] }));
});
